import "../global/basic.css"
import "./login.css"
import { useCallback, useState } from "react";
import { API_URL } from "../shared/api";
import { useNavigate } from "react-router-dom";


export default function LoginPage() {
  const navigate = useNavigate();

  const [username, setUserName] = useState("");
  const title = "1% Quiz";

  const signIn = async (username) =>
    fetch(`${API_URL}/users/${username}`, {
      method: "GET"
    })
    .then(res => {
      if (!res.ok) 
        throw new Error("User not found");
      return res;
    });

  const signUp = async (username) => 
    fetch(`${API_URL}/users`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: username
    })

  const navigateToAccount = useCallback((data) => 
    navigate(`/account/${data.id}`,  { state: { user: data } })
  , [navigate]);

  const signInOrUp = useCallback(() => {
    signIn(username)
      .then(data => data.json())
      .then(navigateToAccount)
      .catch(e => {
        console.log("user "+username+" created.")
        signUp(username)
          .then(data => data.json())
          .then(navigateToAccount)
      })
  }, [username, navigateToAccount]);

  const handleKeyDown = (e) => {
    if(e.key === "Enter") signInOrUp()
  }

  return (<div>
    <header><h1>1% Quiz</h1></header>

    <main className="vertical-container center space-between flex-1 below-top top-margin">
      <div id="join-lobby" className="section-container vertical-container center top-margin">
          <h2 className="no-top-margin">Los geht's!</h2>
          <div className="vertical-container center">
            <input className="decent-input primary" type="text" placeholder="username"
              value={username} onChange={(e) => setUserName(e.target.value)} onKeyDown={handleKeyDown}/>
            <button className="top-margin" onClick={signInOrUp}>Anmelden</button>
        </div>
      </div>

      <div id="info" className="top-margin vertical-container small center">
        <h3>Wie funktioniert {title}?</h3>
        <div className="vertical-container gap-1 center">
          <span>👤 Melde Dich mit Deinem Namen an!</span>
          <span>🎲 Starte ein neues Spiel oder führe ein altes fort!</span>
          <span>✨ Trage deine Antworten ein und markiere deinen Fortschritt!</span>
          <span>📊 Betrachte deine Spielstatistiken im Hub!</span>
        </div>
      </div>
    </main>
  </div>);
}